module.exports = __webpack_public_path__ + "assets/img/Future_004.fc34b0dc-ps.jpg";